var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguageDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "language_dark_svg__cu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m54.88,215c0,88.43,71.69,160.12,160.12,160.12s160.12-71.69,160.12-160.12S303.43,54.88,215,54.88,54.88,126.57,54.88,215h0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "language_dark_svg__dt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m215,49.94c-91.01,0-165.06,74.05-165.06,165.06s74.05,165.06,165.06,165.06,165.06-74.05,165.06-165.06S306.01,49.94,215,49.94Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "language_dark_svg__du",
    x1: 205.83,
    y1: 327.76,
    x2: 330.59,
    y2: 327.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "language_dark_svg__dv",
    x1: 84.07,
    y1: 148.48,
    x2: 312.57,
    y2: 148.48,
    xlinkHref: "#language_dark_svg__du"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "language_dark_svg__ct"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#language_dark_svg__cu)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 215,
    r: 166.12,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "language_dark_svg__ds"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#language_dark_svg__dt)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m322.84,278.48c-36.26-13.77-65.74-36.49-66.03-36.71-2.1-1.63-4.72-2.53-7.38-2.53-3,0-5.86,1.11-8.08,3.12l-30.06,27.36c-2.15,1.95-3.51,4.61-3.84,7.5l-1.38,11.98c-1.26,10.89,2.76,21.88,10.74,29.39,12.81,12.05,14.94,16.21,15.02,16.38,6.54,13.58,8.7,43.94,8.98,54.48.02.8.12,1.61.3,2.39,2.94,12.78,11.27,21.36,23.45,24.16.88.2,1.79.31,2.69.31,2.54,0,4.96-.78,7.02-2.27,2.8-2.02,4.6-5.15,4.93-8.6.34-3.54.83-14.05,1.08-19.91l39.46-56.13c.82-1.17,1.42-2.46,1.79-3.84l8.66-32.79c1.57-5.95-1.58-12.09-7.34-14.28Zm-23.97,38.87l-35.5,50.5c-1.44-13.95-4.3-31.63-9.92-43.3-1.07-2.22-3.91-8.12-20.2-23.44-2.49-2.34-3.74-5.76-3.35-9.16l.87-7.51,19.51-17.76c10.34,7.18,30.1,19.89,54,30.17l-5.41,20.5Z",
    fill: "url(#language_dark_svg__du)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.48,236.7c4.1-3.55,5.31-9.44,2.93-14.32l-14.2-29.19c-.86-1.76-2.14-3.29-3.72-4.45l-14.39-10.49c1.46-1.41,4.1-2.81,7.22-3.86l22.37,16.7c2.06,1.54,4.61,2.38,7.18,2.38.92,0,1.84-.11,2.74-.32,3.46-.81,6.36-3.09,7.97-6.27l10.63-21.02,37.47-1.42c4.91-.19,9.16-3.29,10.83-7.91,1.22-3.38,7.25-20.83,5.86-32.39-.25-2.08-.77-6.41-11.94-21.58-2.25-3.06-5.86-4.88-9.66-4.88-.34,0-.68.01-1.02.04l-22.61,1.93-2.61-1.95,21.9-14.06c5.12-3.29,6.97-9.9,4.3-15.37l-10.35-21.16c-2-4.09-6.23-6.73-10.81-6.73l-155.69.36c-3.17,0-6.15,1.24-8.4,3.46l-17.84,17.62c-3,2.96-4.23,7.34-3.21,11.43l7.03,28.36c1.31,5.28,6.03,9.03,11.47,9.11,0,0,28.44.43,28.58.43,1.66,0,3.31-.38,4.91-1.13.29-.13.87-.41,1.36-.61.59.58,1.65,1.77,3.51,4.23,4.06,5.35-5.48,19.56-11.45,25.93-2.65,2.75-3.83,6.64-3.17,10.4l12.06,68.55c.64,3.61,2.85,6.7,6.07,8.45l51.52,28.12c1.76.96,3.75,1.47,5.75,1.47,2.89,0,5.68-1.04,7.86-2.93l19.56-16.95Zm-28.98-6.65l-39.14-21.37-10.07-57.27c7.7-9.63,23.42-33.42,9.11-52.28-5.09-6.71-11.41-13.88-21.92-13.88-2.99,0-6.17.62-9.46,1.86l-16.5-.25-3.16-12.76,9.48-9.37,143.26-.33,2.35,4.81-27.49,17.65c-3.31,2.13-5.37,5.75-5.51,9.68-.14,3.93,1.66,7.69,4.82,10.04l20.16,15.03c2.06,1.53,4.61,2.38,7.17,2.38.34,0,.68-.01,1.02-.04l20.29-1.73c1.85,2.75,3.1,4.81,3.68,5.86,0,2.75-.85,7.45-2.28,12.7l-36.08,1.37c-4.36.17-8.29,2.69-10.25,6.58l-7.37,14.58-15.47-11.55c-2.06-1.54-4.61-2.38-7.18-2.38-.6,0-1.2.04-1.81.14-3.22.49-19.74,3.56-28.31,15.64-4.28,6.02-5.79,13.21-4.38,20.77.56,3.02,2.24,5.69,4.73,7.5l17.76,12.95,8.87,18.22-6.3,5.46Z",
    fill: "url(#language_dark_svg__dv)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m215,42.88c-94.91,0-172.12,77.21-172.12,172.12s77.21,172.12,172.12,172.12,172.12-77.21,172.12-172.12S309.91,42.88,215,42.88Zm0,320.24c-81.67,0-148.12-66.45-148.12-148.12S133.33,66.88,215,66.88s148.12,66.45,148.12,148.12-66.45,148.12-148.12,148.12Z",
    fill: "#272727"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageDark);
export default __webpack_public_path__ + "static/media/language_dark.1c8c6806a57dde9038b43451eb643a08.svg";
export { ForwardRef as ReactComponent };